Array.prototype.contains = function (element) {
  return this.indexOf(element) > -1;
};

Array.prototype.any = function (elements) {
  return this.some((item) => elements.indexOf(item) >= 0);
};
